import { toLonLat } from 'ol/proj';

const parseCoords = (coordinates) => {
  if (!coordinates) return null;
  const lonLat = toLonLat(coordinates);
  return { lon: lonLat[0], lat: lonLat[1] };
};

export default parseCoords;
